import { apiService } from 'services/api/api';
import { CheckFlagrData } from './types';

export const getUserData = () => apiService.get(`/user/me`);
export const getUserFeatures = () => apiService.get(`/company/features-access`);
export const checkFlagr = (flagId: number) => apiService.get<CheckFlagrData>(`/company/check-feature-flag/${flagId}`);
export const getPlanMigration = (companyId: number) => apiService.get(`/company/combo/plan-migration/${companyId}`);

export default getUserData;
